import React from 'react';
import config from 'config';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Container from 'components/layout/Container';
import { Link } from 'react-router-dom';
import './Footer.scss';

function Footer() {
  const branchInfo = useSelector(state => state.branch);
  return (
    <div class="footer">
      <Container>
        <div className="logo">
          <img
            src={branchInfo.logo}
            alt="logo"
            width="120"
          />
        </div>
        <div className="copyright">
          <div class="company" dangerouslySetInnerHTML={{
            __html: branchInfo.companyInfo.replace(/\n/g, '<br>')
          }} />
        </div>
        <div className="menu_and_etc">
          {branchInfo.partnerInfo.pm_state !== 'JOIN' ? <div className="footer-button-group">
            <Link to="/cscenter/notice">
              <FormattedMessage id="footer.link_notice" />
            </Link>
            <Link to="/about/terms">
              <FormattedMessage id="footer.link_terms" />
            </Link>
            <Link to="/about/privacy">
              <FormattedMessage id="footer.link_privacy" />
            </Link>
          </div> : undefined}
          <div className="kakao-link">
            <a href={branchInfo.csInfo.inquery.link} target="_blank">
              {branchInfo.csInfo.inquery.text}
            </a>
          </div>
          <p>
            <FormattedMessage id="footer.cs_account" />
            {' : '}
            <a
              class="email-link"
              href={`mailto:${branchInfo.csInfo.account_email}`}
            >
              {branchInfo.csInfo.account_email}
            </a>
            {' / '}
            <FormattedMessage id="footer.cs_pay" />
            {' : '}
            <a
              class="email-link"
              href={`mailto:${branchInfo.csInfo.deposit_email}`}
            >
              {branchInfo.csInfo.deposit_email}
            </a>
          </p>
          <p>{branchInfo.csInfo.text}</p>
        </div>
      </Container>
    </div>
  );
}

export default Footer;
